function initCartCgvValidation(root = document) {
  // Formulaire du cart : page cart (id="cart") OU drawer
  const form =
    root.querySelector('form[action="/cart"]') ||
    root.querySelector('form#cart') ||
    root.querySelector('.Cart.Drawer__Content form');

  const checkbox = root.querySelector('[data-cgv-checkbox]');
  const errorMessage = root.querySelector('[data-cgv-error]');

  if (!form || !checkbox || !errorMessage) return;

  // Évite les doublons
  if (form.__cgvBound) return;
  form.__cgvBound = true;

  form.addEventListener('submit', function (e) {
    if (!checkbox.checked) {
      e.preventDefault();
      e.stopPropagation();
      errorMessage.hidden = false;
      errorMessage.classList.add('is-visible');
      checkbox.focus();
    } else {
      errorMessage.hidden = true;
      errorMessage.classList.remove('is-visible');
    }
  });
}

// Premier montage (page cart incluse)
document.addEventListener('DOMContentLoaded', () => initCartCgvValidation());

/* === Easy Bundle – CGV injection + validation (external custom.js) === */
(function () {
  const FOOTER_SELECTOR = '.gbbFooterActionContainer';
  const NEXT_BTN_SELECTOR = '.gbbFooterNextButton';

  // --- utils ---
  function escapeHtml(s) {
    return String(s ?? '').replace(/[&<>"']/g, (c) => (
      { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
    ));
  }

  function buildCgvHtml() {
    const strings = window.cartStrings || {};
    const text = String(strings.cgv_text || '');
    const link = String(strings.cgv_link || '#');
    const errorMsg = String(strings.cgv_error_msg || '');

    const parts = text.split('-');
    const before = (parts[0] || '').trim();
    const after  = (parts.length > 1 ? parts[parts.length - 1] : '').trim();

    // équivalent du `{% if request.page_type == 'cart' %}form="cart"{% endif %}`
    const onCartPage = /^\/cart(?:\/)?$/i.test(location.pathname);
    const formAttr = onCartPage ? ' form="cart"' : '';

    return `
<div class="CartDrawer__CgvContainer" data-cgv>
  <label class="CartDrawer__CgvCheckbox">
    <input type="checkbox" data-cgv-checkbox${formAttr}>
    <span class="CartDrawer__CgvLabel">
      ${escapeHtml(before)}
      ${after ? ` <a href="${escapeHtml(link)}" target="_blank">${escapeHtml(after)}</a>` : ''}
    </span>
  </label>
  <div class="CartDrawer__CgvError" data-cgv-error hidden>${escapeHtml(errorMsg)}</div>
</div>`.trim();
  }

  function isAddToCartStep(btn) {
    const label = (btn?.textContent || '').toLowerCase().trim();
    return label.includes('ajouter') || label.includes('add to cart');
  }

  function syncCgvVisibility(footer) {
    const nextBtn = footer.querySelector(NEXT_BTN_SELECTOR);
    const cgvWrap = footer.querySelector('[data-cgv]');
    const errorEl = footer.querySelector('[data-cgv-error]');
    if (!nextBtn || !cgvWrap || !errorEl) return;

    if (isAddToCartStep(nextBtn)) {
      cgvWrap.style.display = '';
    } else {
      cgvWrap.style.display = 'none';
      errorEl.hidden = true;
      errorEl.classList.remove('is-visible');
    }
  }

  function bindFooterValidation(footer) {
    if (footer.__cgvBound) return;
    footer.__cgvBound = true;

    const nextBtn  = footer.querySelector(NEXT_BTN_SELECTOR);
    const checkbox = footer.querySelector('[data-cgv-checkbox]');
    const errorEl  = footer.querySelector('[data-cgv-error]');
    if (!nextBtn || !checkbox || !errorEl) return;

    nextBtn.addEventListener('click', function (e) {
      if (!isAddToCartStep(nextBtn)) return;
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation?.();
        errorEl.hidden = false;
        errorEl.classList.add('is-visible');
        checkbox.focus();
      } else {
        errorEl.hidden = true;
        errorEl.classList.remove('is-visible');
      }
    }, true);

    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        errorEl.hidden = true;
        errorEl.classList.remove('is-visible');
      }
    });

    footer.addEventListener('click', () => {
      setTimeout(() => syncCgvVisibility(footer), 0);
    });

    syncCgvVisibility(footer);
  }

  function injectInFooter(footer) {
    if (!footer.querySelector('[data-cgv]')) {
      footer.insertAdjacentHTML('afterbegin', buildCgvHtml());
    }
    bindFooterValidation(footer);
  }

  function scanAndInject(root = document) {
    const containers = root.querySelectorAll('#MainContent #myContent, #myContent');
    if (containers.length) {
      containers.forEach(container => {
        const footer = container.querySelector(FOOTER_SELECTOR) || document.querySelector(FOOTER_SELECTOR);
        if (footer) injectInFooter(footer);
      });
    } else {
      // fallback : si pas de #myContent détecté, tente directement sur la page
      root.querySelectorAll(FOOTER_SELECTOR).forEach(injectInFooter);
    }
  }

  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === 'childList') {
        const added = [...m.addedNodes];
        if (added.some(n => n.nodeType === 1 && (
          n.id === 'myContent' ||
          n.querySelector?.('#myContent') ||
          n.matches?.(FOOTER_SELECTOR) ||
          n.querySelector?.(FOOTER_SELECTOR)
        ))) {
          scanAndInject(document);
          break;
        }
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    scanAndInject(document);
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
